module.exports = __webpack_public_path__ + "static/media/box-download.ad9e29a1.png";